export default {
  buttons: {
    send_code: 'Wyślij kod logowania',
  },
  placeholders: {
    mobile_number: 'Numer telefonu',
    email: 'Adres e-mail',
  },
  feedback: {
    phone_number_required: 'Podaj numer telefonu',
    email_required: 'Podaj swój adres e-mail',
  },
};
